/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

/* eslint-disable react/jsx-props-no-spreading */
import React, { FC } from "react";
import LaddaButton, { EXPAND_LEFT } from "react-ladda-button";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { v4 as uuid } from "uuid";
import { useTranslation } from "react-i18next";
import { ConfirmModalProps } from "../../types/components/modal";

export const ConfirmModal: FC<ConfirmModalProps> = (props) => {
  const { t } = useTranslation();
  const {
    header,
    body,
    confirmBtnName,
    cancelBtnName,
    saveBtnName,
    loading,
    confirmBtnVariant,
    cancelBtnVariant,
    saveBtnVariant,
    disableConfirmBtn,
    size,
    confirm,
    cancel,
    save,
    type = "confirm",
    children,
    icon,
  } = props;
  return (
    <Modal
      size={size || (save ? "lg" : "sm")}
      className="confirm-modal"
      centered
      {...props}
    >
      <Modal.Header>
        {type === "confirm" && !icon && (
          <div className="swal2-icon swal2-warning swal2-animate-warning-icon" />
        )}
        {icon}
      </Modal.Header>
      <Modal.Body>
        {/* @ts-ignore */}
        <h2 className="text-center">{header || t("general.confirmation")}</h2>
        {typeof body === "string" ? (
          <div className="text-center">{body}</div>
        ) : (
          body || children
        )}
      </Modal.Body>
      <Modal.Footer style={{ marginTop: 9 }} className="flex-center">
        {save && (
          <LaddaButton
            key={uuid()}
            type="button"
            className={`btn btn-${saveBtnVariant || "primary"}`}
            loading={loading}
            data-style={EXPAND_LEFT}
            onClick={save}
          >
            {!loading && (saveBtnName || t("save"))}
          </LaddaButton>
        )}
        {confirm && (
          <LaddaButton
            key={uuid()}
            type="button"
            className={`btn btn-${confirmBtnVariant || "danger"}`}
            loading={loading}
            data-style={EXPAND_LEFT}
            onClick={confirm}
            disabled={disableConfirmBtn}
          >
            {!loading && (confirmBtnName || t("general.confirm"))}
          </LaddaButton>
        )}
        {cancel && (
          <Button
            variant={cancelBtnVariant || "secondary"}
            key={uuid()}
            onClick={cancel}
          >
            {cancelBtnName || t("cancel")}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};
